module.exports = {"successAlertMessage":"Er is een e-mail met instructies naar {email} gestuurd. Volg de instructies in de e-mail om uw wachtwoord opnieuw in te stellen.","validation":{"required":"Deze waarde is verplicht en mag niet leeg zijn","email":"Vul a.u.b een geldig e-mail adres in"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/forgot-password-form.json
// module id = RhIj
// module chunks = 1